import {
  ResendVerification,
  ResetPassword,
  SignIn,
  SignUp,
} from "components/user";
import { Redirect, Route, Switch, useLocation } from "react-router";
import * as Routes from "routes";
import { saveRedirectInfo } from "utils/redirect-manager";

import { AuthLayout } from "./auth-layout";
import MarketingPage from "./marketing";

export const SignedOut = () => {
  const prevLocation = useLocation();
  if (
    prevLocation.pathname !== Routes.signIn &&
    prevLocation.pathname !== Routes.signUp &&
    prevLocation.pathname !== "/"
  ) {
    saveRedirectInfo(prevLocation.pathname, prevLocation.search);
  }

  return (
    <div className="flex flex-col justify-center items-center min-h-screen relative">
      <Switch>
        <Route exact path={[Routes.signIn, "/"]}>
          <AuthLayout>
            <SignIn />
          </AuthLayout>
        </Route>
        <Route exact path={Routes.signUp}>
          <div className="flex w-full max-w-5xl flex-col lg:items-start items-center justify-center gap-10 px-4 py-8 lg:flex-row">
            <MarketingPage />
            <SignUp />
          </div>
        </Route>
        <Route exact path={Routes.resetPassword}>
          <AuthLayout>
            <ResetPassword />
          </AuthLayout>
        </Route>
        <Route exact path={Routes.resendVerification}>
          <AuthLayout>
            <ResendVerification />
          </AuthLayout>
        </Route>
        <Route path="*">
          <Redirect to={Routes.signIn} />
        </Route>
      </Switch>

      <div className="absolute bottom-0 left-0 p-2">
        <span className="text-xs text-muted-foreground">
          v2.1.0.{import.meta.env.VITE_BUILD_NO}
        </span>
      </div>
    </div>
  );
};
